import axios from 'axios';
import { Store, useStore } from 'vuex';
import useStickyAlerts from '@/modules/alerts/composables/useStickyAlerts';
import BasicStickyAlertProps, {
  BASIC_STICKY_ALERT_TYPE,
} from '@/modules/alerts/models/basic-sticky-alert-props';
import StickyAlert from '@/modules/alerts/models/sticky-alert';
import { STICKY_ALERT_TYPE } from '@/modules/alerts/models/sticky-alert-type';
import { inject } from 'vue';
import { configurationKey } from '@/injections';
import { Router, useRouter } from 'vue-router';
import { ComposerTranslation, useI18n } from 'vue-i18n';
import { Configuration } from '@/types/configuration.d';

interface SignOutContext {
  config: Configuration;
  t: ComposerTranslation;
  store: Store<any>;
  router: Router;
}

let c: SignOutContext = { config: null, t: null, store: null, router: null };

const initializeSignOutContext = () => {
  const config = inject(configurationKey);
  const { t } = useI18n();
  const store = useStore();
  const router = useRouter();
  c = { config, t, store, router };
};

const { addAlert } = useStickyAlerts();

const showSuccessAlert = () => {
  const props = new BasicStickyAlertProps(BASIC_STICKY_ALERT_TYPE.SUCCESS, c.t('signOutSuccess'), {
    timeoutMs: 7000,
  });
  const successAlert = new StickyAlert(STICKY_ALERT_TYPE.BASIC, props);
  addAlert(successAlert);
};

const showErrorAlert = (message: string) => {
  const props = new BasicStickyAlertProps(BASIC_STICKY_ALERT_TYPE.ERROR, message, { timeoutMs: 0 });
  const errorAlert = new StickyAlert(STICKY_ALERT_TYPE.BASIC, props);
  addAlert(errorAlert);
};

const resetToLoggedOutState = () => {
  c.router.push({ name: 'Home' });
  if (c.config.orderTypesEnabled) {
    c.store.dispatch('cart/getCarts');
  }
  if (c.config.allowCouponClipping) {
    c.store.dispatch('coupons/clearUserCoupons');
  }
  c.store.dispatch('cart/reload');
  c.store.dispatch('lists/fetch');
  c.store.dispatch('membership/hideFeeAlert');
};

const signOutAllDevices = async () => {
  console.log('Signing out of all devices');
  try {
    await axios.post('/api/auth/invalidateAllSessions');
  } catch (error) {
    console.error(error);
    showErrorAlert(c.t('signOutFailed'));
    return false;
  }

  showSuccessAlert();
  resetToLoggedOutState();
  return true;
};

export default () => {
  initializeSignOutContext();
  return { signOutAllDevices };
};
